/**
 * Relay serializes GraphQL variables itself. Encoding this value here turns a
 * workflow named `AutoClaimer RUJI Staking` into a different literal name
 * (`AutoClaimer%20RUJI%20Staking`) and makes a valid workflow look missing.
 */
export const workflowQueryVariables = (
  workflowId?: string,
  workflowName?: string
): { id?: string; name?: string } => {
  const variables: { id?: string; name?: string } = {};
  if (workflowId) variables.id = workflowId;
  if (workflowName) variables.name = workflowName;
  return variables;
};
